<template>
  <div class="invite-page">
    <AppNavBar
      title="betterWE减脂营"
      :placeholder="true"
      :options="options"
      :zIndex="200"
    >
    </AppNavBar>
    <div class="invite-loaded" v-if="activityConfig">
      <img class="bg-image" :src="activityConfig.background_image" alt="" />
      <img
        class="rule-btn"
        @click="handelShowRule"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/3997d7b6205f29f5ab207e2b5d8f4efb.png"
        alt=""
      />
      <div class="invite-container">
        <div class="your-price">
          <img
            class="prize-image-item your-price-image"
            :src="activityConfig.invite_prize_image"
            alt=""
          />
          <div class="invite-info">
            <div class="invite-btn" @click="handleShowShare" id="invite-btn"
              >立即邀请好友<span class="iconfont icon-you"></span
            ></div>
            <div class="info-list">
              <div class="info-item info-line"
                ><span class="info-pink">{{
                  (inviteNum && inviteNum.is_add_accompany_count) || 0
                }}</span
                ><span>已添加</span></div
              >
              <div class="info-item info-line"
                ><span class="info-pink">{{
                  (inviteNum && inviteNum.is_trial_product_count) || 0
                }}</span
                ><span>已体验</span></div
              >
              <div class="info-item"
                ><span class="info-pink">{{
                  (inviteNum && inviteNum.product_count) || 0
                }}</span
                ><span>已成交</span></div
              >
              <div class="info-pink info-all" @click="handelAll"
                >查看全部>></div
              >
            </div>
          </div>
        </div>
        <div class="inviter-price">
          <img
            class="prize-image-item"
            :src="activityConfig.invited_prize_image"
            alt=""
          />
          <CourseContainer class="course-container" />
        </div>
      </div>
      <img
        class="logo"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d647d30b88bd4a92cf591a502889808b.png"
        alt=""
      />
      <div
        class="fixed-btn invite-btn"
        v-show="showFixed"
        @click="handleShowShare"
        >立即邀请好友<span class="iconfont icon-you"></span
      ></div>
    </div>
    <van-overlay :show="showRule" @click="bindClose" z-index="300">
      <RuleComponent @close="bindClose" />
    </van-overlay>
    <!-- 分享组件 -->
    <ShareComponent
      v-model="showShare"
      :options="iconList"
      @cancel="bindCancel"
      @select="bindSelect"
      :qrcodeUrl="qrcodeUrl"
    />
  </div>
</template>

<script>
import AppNavBar from '@/components/app/nav-bar/index.vue'
import RuleComponent from './components/rule.vue'
import ShareComponent from '@/components/app/share/share.vue'
import CourseContainer from './components/course-container.vue'
import { eventObj, defultIcons } from '@/components/app/share/share-method.js'
export default {
  components: { RuleComponent, ShareComponent, AppNavBar, CourseContainer },
  data() {
    return {
      options: {},
      showRule: false,
      showShare: false,
      shareOptions: {
        desc: '接收邀请，开启减脂之旅！',
        title: '赠送您3日真人营养师指导',
        thumbnail:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e93143f47e6418437ba209310fb2f306.png' // 分享的缩略图的url
      },
      iconList: defultIcons,
      showFixed: true,
      activityConfig: null,
      inviteNum: null,
      isStart: false,
      isEnd: true
    }
  },
  computed: {
    qrcodeUrl() {
      let uid =
        (this.$store.state.userInfo &&
          this.$store.state.userInfo.user &&
          this.$store.state.userInfo.user.uid) ||
        0
      let avatar =
        (this.$store.state.userInfo &&
          this.$store.state.userInfo.user &&
          this.$store.state.userInfo.user.head_img) ||
        ''
      let nickname =
        (this.$store.state.userInfo &&
          this.$store.state.userInfo.user &&
          this.$store.state.userInfo.user.truename) ||
        ''
      return `${
        location.origin
      }/camp-invite-v4/invite?uid=${uid}&avatar=${encodeURIComponent(
        avatar
      )}&nickname=${encodeURIComponent(nickname)}`
    }
  },
  created() {
    this.getActivityConfig()
    this.getInviteNum()
  },
  mounted() {
    this.addScrollEvent()
  },
  beforeDestroy() {
    this.removeScrollEvent()
  },
  methods: {
    addScrollEvent() {
      setTimeout(() => {
        window.addEventListener('scroll', this.bindScroll)
      }, 100)
    },
    removeScrollEvent() {
      window.removeEventListener('scroll', this.bindScroll)
    },
    bindScroll(e) {
      let scrollTop =
        e.target.documentElement.scrollTop ||
        e.target.body.scrollTop ||
        e.target.pageYOffset
      let el = document.getElementById('invite-btn')
      let top = el.getBoundingClientRect().top
      let bottom = el.getBoundingClientRect().bottom
      if (scrollTop >= top - window.screen.height && bottom > 0) {
        this.showFixed = false
      } else {
        this.showFixed = true
      }
    },
    handelAll() {
      if (this.canActivity()) {
        this.$router.push('/camp-invite-v4/detail')
      }
    },
    handelShowRule() {
      if (this.canActivity()) {
        this.showRule = true
      }
    },
    bindClose() {
      this.showRule = false
    },
    bindCancel() {
      this.showShare = false
    },
    handleShowShare() {
      if (this.canActivity()) {
        this.showShare = true
      }
    },
    async bindSelect(options) {
      this.showShare = false
      let shareOptions = Object.assign({}, this.shareOptions)
      let name =
        this.$store.state.userInfo.user &&
        this.$store.state.userInfo.user.truename
      shareOptions.title = name + '赠送您3日真人营养师指导'
      switch (options.id) {
        // 分享链接到微信好友
        case 1:
          shareOptions.url = this.qrcodeUrl
          eventObj.shareLinkToWxFriend(shareOptions)
          break
        // 分享链接到微信朋友圈
        case 2:
          shareOptions.url = this.qrcodeUrl
          eventObj.shareLinkToWxCircle(shareOptions)
          break
        // 分享图片到微信好友 图片 -> base64
        case 3:
          break
      }
    },
    canActivity() {
      if (!this.isStart) {
        this.$toast('活动未开始')
        return false
      } else if (this.isEnd) {
        this.$toast('活动已结束')
        return false
      }
      return true
    },
    async getActivityConfig() {
      let res = await this.$http
        .getApp('/api/v1/Introduction/config', {})
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.activityConfig = res.data
          this.isEnd =
            res.time * 1000 >=
              new Date(
                this.activityConfig.end_date.replace(/-/g, '/')
              ).getTime() || !this.activityConfig.state
          this.isStart =
            res.time * 1000 >=
            new Date(
              this.activityConfig.start_date.replace(/-/g, '/')
            ).getTime()
          this.canActivity()
        } else {
          this.$toast(res.msg)
        }
      }
    },
    async getInviteNum() {
      let res = await this.$http
        .getApp('api/v1/Introduction/getInviteNum', {})
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.inviteNum = res.data
        } else {
          this.$toast(res.msg)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.invite-page {
  min-height: 100vh;
  .invite-loaded {
    position: relative;
    overflow: hidden;
    z-index: 1;
    background-color: rgba(222, 240, 255, 1);
  }
  .bg-image {
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    z-index: -1;
  }
  .rule-btn {
    position: fixed;
    right: 0;
    top: 160px;
    width: 28px;
    z-index: 1;
  }
  .prize-image-item {
    width: 100%;
  }
  .your-price-image {
    height: 585px;
  }
  .invite-container {
    margin-top: 345px;
    margin-bottom: 33px;
    padding: 0px 12px;
    .your-price {
      position: relative;
      min-height: 116px;
      margin-bottom: 20px;
      padding-bottom: 22px;
    }
    .invite-info {
      position: absolute;
      width: 100%;
      box-sizing: border-box;
      bottom: 0;
      left: 0;
      padding: 20px 16px 22px;
      background: #ffffff;
      border-radius: 8px;
      .invite-btn {
        height: 46px;
        background: linear-gradient(270deg, #ff2774 0%, #ff366d 100%);
        border-radius: 25px;
        font-weight: bold;
        font-size: 18px;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;
        .iconfont {
          margin-left: 4px;
          font-weight: bold;
        }
      }
      .info-list {
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.5);
        line-height: 18px;
        font-size: 14px;
        .info-item {
          padding: 0px 5px;
        }
        .info-line {
          position: relative;
        }
        .info-line::after {
          content: '';
          width: 1px;
          height: 15px;
          right: 0;
          top: 50%;
          transform: translate(0%, -50%);
          background-color: rgba(0, 0, 0, 0.5);
          position: absolute;
        }
        .info-pink {
          color: rgba(255, 42, 116, 1);
        }
        .info-all {
          margin-left: 8px;
          text-decoration: underline;
        }
      }
    }
    .your-price {
    }
  }
  .inviter-price {
    position: relative;
    .course-container {
      position: absolute;
      left: 0;
      width: 100%;
      top: 309px;
    }
  }
  .logo {
    margin: 0 auto 30px;
    height: 14px;
  }
  .fixed-btn {
    position: fixed;
    left: 50%;
    bottom: 20px;
    transform: translate(-50%, 0%);
    width: 319px;
    height: 46px;
    background: linear-gradient(270deg, #ff2774 0%, #ff366d 100%);
    border-radius: 25px;
    font-weight: bold;
    font-size: 18px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    .iconfont {
      margin-left: 4px;
      font-weight: bold;
    }
  }
}
</style>
